import { Globe, Github, Heart } from 'lucide-react'

export default function Header() {
  return (
    <header className="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Globe className="w-8 h-8 text-primary-600" />
            <span className="text-2xl font-bold text-gray-900">Domain Brainstorm</span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-6">
            <a 
              href="#features" 
              className="text-gray-600 hover:text-primary-600 transition-colors duration-200"
            >
              Features
            </a>
            <a 
              href="#how-it-works" 
              className="text-gray-600 hover:text-primary-600 transition-colors duration-200"
            >
              How It Works
            </a>
            <a 
              href="https://github.com/yourusername/domain-brainstorm" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1 text-gray-600 hover:text-primary-600 transition-colors duration-200"
            >
              <Github className="w-4 h-4" />
              <span>GitHub</span>
            </a>
          </nav>
          
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Heart className="w-4 h-4 text-red-500" />
            <span>Made with love</span>
          </div>
        </div>
      </div>
    </header>
  )
}
